import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  employerTagsKey,
  employerTagsList,
  errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useGetEmployerTagsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  enabled: boolean;
};

export const useGetEmployerTags = ({
  setErrorText = () => { },
  enabled
}: useGetEmployerTagsProps) => {
  const {
    data: tagsData,
    isFetching: isLoadingTags,
  } = useQuery({
    queryKey: [employerTagsKey],
    enabled: enabled,
    queryFn: () => {
      return axiosInstance
        .get(employerTagsList)
        .then((res) => res.data);
    },
    onSuccess: (data) => {
      if (data.object) {
        setErrorText('');
      }
      if (data.status !== 200) {
        setErrorText(data.message);
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
    refetchOnWindowFocus: false,
  });

  return {
    tagsData,
    isLoadingTags
  };
};
